import { useEffect } from "react";
//components
import { Button } from "../components/ui/buttons/Button";
//hooks
import { useLocation } from 'react-router-dom';
import { useLoading } from "../contexts/LoadingContext";
import { useSuccess } from "../contexts/SuccessContext";
import { useError } from "../contexts/ErrorContext";
//api
import { approveSpeedAPI } from "../services/liveTrakAPI"

/**
 * User, usually supervisor or higher, receives link in their email to this page to approve or not approve a speed. This is sent out in response to a user inputting a pass time that causes the pig's speed to be out of bounds.
 * 
 * @returns {JSX.Element}
 * 
 * @category Pages
 */
export const ApproveSpeed = () => {
    //get params from url
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const approve = queryParams.get('a') === "true" ? true : false;
    const approver = queryParams.get('u');
    const token = queryParams.get('t');
   
    const {showLoading, hideLoading} = useLoading()
    const {showError} = useError()
    const {timeoutSuccess} = useSuccess()

    //change page message depending on approval
    const message = approve
        ? "want to" 
        : "don't want to"

    //submit to api
    const handleSubmit = async() => {
        showLoading("Submitting...")

        const response = await approveSpeedAPI({
            UserID: approver,
            approvalToken: token,
            approved: approve
        })
                     
        if(!response.success){
            
            hideLoading()

            showError(response.message)
            
            return
        }

        hideLoading()

        timeoutSuccess("Saved")
        
    }

    useEffect(() => {
        document.title =  `MarTrak - Approve Speed`
    }, []);

    return(
        <div className="flex items-center justify-center bg-white">
            <div className="flex flex-col items-center justify-center p-8 mb-0 space-y-4 rounded-lg shadow-2xl bg-white">
                
                    <p>Are you sure you {message} approve this pass time?</p>
                    
                    <div className="my-4">
                        <Button onClick={() => handleSubmit()}>{approve ? "Approve" : "Don't approve"}</Button>
                    </div>

            </div>
        </div>
    )
}